import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

export default class SectionManager extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newSectionLabel: ''
        };
    }

    handleAddSection = () => {
        const { sections, onUpdateSections } = this.props;
        const label = this.state.newSectionLabel.trim();
        if (!label) return;

        const sectionId = label.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');
        const maxOrder = sections.reduce((max, s) => Math.max(max, s.order || 0), 0);

        onUpdateSections([...sections, { sectionId, label, order: maxOrder + 1, collapsible: false }]);
        this.setState({ newSectionLabel: '' });
    };

    handleRemoveSection = (sectionId) => {
        const { sections, onUpdateSections } = this.props;
        onUpdateSections(sections.filter((s) => s.sectionId !== sectionId));
    };

    handleUpdateLabel = (sectionId, newLabel) => {
        const { sections, onUpdateSections } = this.props;
        onUpdateSections(
            sections.map((s) => (s.sectionId === sectionId ? { ...s, label: newLabel } : s))
        );
    };

    handleMoveUp = (index) => {
        if (index === 0) return;
        const { sections, onUpdateSections } = this.props;
        const arr = [...sections];
        [arr[index - 1], arr[index]] = [arr[index], arr[index - 1]];
        arr.forEach((s, i) => { s.order = i + 1; });
        onUpdateSections(arr);
    };

    handleMoveDown = (index) => {
        const { sections, onUpdateSections } = this.props;
        if (index >= sections.length - 1) return;
        const arr = [...sections];
        [arr[index], arr[index + 1]] = [arr[index + 1], arr[index]];
        arr.forEach((s, i) => { s.order = i + 1; });
        onUpdateSections(arr);
    };

    render() {
        const { sections } = this.props;
        const sorted = [...sections].sort((a, b) => (a.order || 0) - (b.order || 0));

        return (
            <div style={{ padding: '10px' }}>
                <h6 style={{ fontWeight: 'bold', marginBottom: '10px' }}>Sections</h6>
                {sorted.map((section, index) => (
                    <div key={section.sectionId} className="d-flex align-items-center mb-2">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            value={section.label}
                            onChange={(e) => this.handleUpdateLabel(section.sectionId, e.target.value)}
                            style={{ flex: 1, marginRight: '4px' }}
                        />
                        <button className="btn btn-sm btn-link" onClick={() => this.handleMoveUp(index)} disabled={index === 0}>
                            <i className="fa fa-arrow-up" />
                        </button>
                        <button className="btn btn-sm btn-link" onClick={() => this.handleMoveDown(index)} disabled={index === sorted.length - 1}>
                            <i className="fa fa-arrow-down" />
                        </button>
                        <button className="btn btn-sm btn-link text-danger" onClick={() => this.handleRemoveSection(section.sectionId)}>
                            <i className="fa fa-times" />
                        </button>
                    </div>
                ))}
                <div className="d-flex mt-2">
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="New section name"
                        value={this.state.newSectionLabel}
                        onChange={(e) => this.setState({ newSectionLabel: e.target.value })}
                        onKeyDown={(e) => e.key === 'Enter' && this.handleAddSection()}
                        style={{ flex: 1, marginRight: '4px' }}
                    />
                    <Button variant="outline-primary" size="sm" onClick={this.handleAddSection}>
                        <i className="fa fa-plus" />
                    </Button>
                </div>
            </div>
        );
    }
}
